import { useEffect, useRef, useState } from 'react';
import { Input } from '../../shared/ui/Input/Input';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions/index.js';
import { Availability } from '../../entities/Availability/index.js';
import { Costs } from '../../entities/Costs/index.js';
import { toast, ToastContainer } from 'react-toastify';
import { UploadPicture } from '../UploadPicture/index.js';
import { AddAdditionalPictures } from './AddAdditionalPictures.jsx';
import { SEOMetatagsForm } from '../../shared/ui/SEOMetatagsForm';
import { MeasurementsForm } from '../../shared/ui/MeasurementsForm/MeasurementsForm';

export const CreateProductForm = () => {
  const [categories, setCategories] = useState([]);
  const [modificators, setModificators] = useState([]);
  const [additionalPictures, setAdditionalPictures] = useState([]);
  const [mainImage, setMainImage] = useState(null);
  const [form, setForm] = useState({
    title: '',
    description: '',
    sku: '',
    categoryId: 1,
    mainLanguageId: 1,
    availability: {
      availableInAllCountries: true,
      allowedCountriesIds: [],
      disallowedCountriesIds: [],
    },
    basePricing: {
      costs: [],
    },
    SEOMetatags: {
      Title: null,
      Description: null,
      Keywords: null,
    },
    measurements: {
      WeightInGramms: 0,
      HeightInMillimeters: 0,
      LengthInMillimeters: 0,
      WidthInMillimeters: 0
    },
  });
  const toastRef = useRef(null);

  const handleChangeCost = (value) => {
    setForm((prev) => {
      const newCosts = prev.basePricing.costs.map((i) => {
        if (i.countryId === value.countryId) {
          return {
            ...i,
            costs: i.costs.map((z) => {
              if (z.currencyId === value.value.currencyId) {
                return {
                  ...z,
                  value: value.value.newValue,
                };
              } else {
                return z;
              }
            }),
          };
        } else {
          return i;
        }
      });

      return { ...prev, basePricing: { costs: newCosts } };
    });
  };

  const handleRequest = async () => {
    toastRef.current = toast('Идёт запрос...', { isLoading: true, autoClose: false });
    try {
      const body = new FormData();
      body.append('mainImg', mainImage);
      body.append('model', JSON.stringify(form));
      const productResponse = await apiRequests.products.create(body);

      if (additionalPictures.length) {
        const queries = additionalPictures.map((i) =>
          apiRequests.products.addPhoto(i, productResponse.id),
        );
        await Promise.all(queries);
      }
      toast.update(toastRef.current, {
        isLoading: false,
        type: 'success',
        render: 'Товар успешно добавлен',
        autoClose: 3500,
      });
    } catch (e) {
      console.error('error create product: ', e);
      toast.update(toastRef.current, {
        isLoading: false,
        type: 'error',
        render: 'Произошла ошибка',
        autoClose: 3500,
      });
    }
  };

  const handleDeletePrice = (countryId) => {
    setForm((prev) => {
      const costs = prev.basePricing.costs.filter((i) => i.countryId !== countryId);
      return { ...prev, basePricing: { costs } };
    });
  };

  useEffect(() => {
    apiRequests.products.getCategories().then((res) => {
      setCategories(res);
    });
    apiRequests.products.getModificators().then((res) => {
      setModificators(res);
    });
  }, []);

  return (
    <div>
      <div className="page-content mb-3">
        <div className="mb-3">
          <Input
            label={'Название'}
            placeholder={'Джинсы'}
            value={form.title}
            onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
          />
        </div>

        <div className="mb-3">
          <Input
            label={'Артикул'}
            placeholder={'Артикул'}
            onChange={(e) => setForm((prev) => ({ ...prev, sku: e.target.value }))}
          />
        </div>

        <LanguageOptions
          onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
        />

        <div className="mb-3">
          <label htmlFor="categories" className="form-label">
            Категория
          </label>
          <select
            value={form.categoryId}
            onChange={(e) => setForm((prev) => ({ ...prev, categoryId: e.target.value }))}
            id="categories"
            className="form-select"
          >
            {categories.items?.map((i) => (
              <option key={i.id} value={i.id}>
                {i.title}
              </option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label htmlFor="description" className="form-label">
            Описание
          </label>
          <textarea
            onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))}
            className="form-control"
            id="description"
            rows="3"
          ></textarea>
        </div>

        <div className="form-section border-bottom mb-3">
          <h5 className="mb-3 mt-3">Цена:</h5>
          <div className="mb-3">
            <Costs
              onDelete={handleDeletePrice}
              onChange={(value) => handleChangeCost(value)}
              onAdd={(value) =>
                setForm((prev) => ({
                  ...prev,
                  basePricing: { costs: [...prev.basePricing.costs, value] },
                }))
              }
            />
          </div>
        </div>

        <div className="form-section border-bottom mb-3">
          <h5 className="mb-3 mt-3">Доступность:</h5>
          <div className="mb-3">
            <Availability
              onSelect={(val) =>
                setForm((prev) => ({
                  ...prev,
                  availability: { ...prev.availability, availableInAllCountries: val },
                }))
              }
              onSelectAllowed={(val) =>
                setForm((prev) => ({
                  ...prev,
                  availability: { ...prev.availability, allowedCountriesIds: val },
                }))
              }
              onSelectDisallowed={(val) =>
                setForm((prev) => ({
                  ...prev,
                  availability: { ...prev.availability, disallowedCountriesIds: val },
                }))
              }
            />
          </div>
        </div>

        <AddAdditionalPictures
          values={additionalPictures}
          onDelete={(value) => setAdditionalPictures((prev) => prev.filter((i) => i !== value))}
          onAdd={(value) => setAdditionalPictures((prev) => [...prev, value])}
        />

        <div className="form-section border-bottom mb-3">
          <MeasurementsForm
            measurements={form.measurements}
            onChange={(measurements) => setForm((prev) => ({ ...prev, measurements }))}
          />
        </div>

        <div className="form-section border-bottom mb-3">
          <SEOMetatagsForm
            seoMetatags={form.SEOMetatags}
            onChange={(metaTags) => setForm((prev) => ({ ...prev, SEOMetatags: metaTags }))}
          />
        </div>

        <UploadPicture onSelect={setMainImage} entityType="product" />
      </div>

      <div className="button-content button-right">
        <a onClick={handleRequest} className="at-btn at-btn-medium">
          Создать
        </a>
      </div>
      <ToastContainer />
    </div>
  );
};
